import React, { useState, useEffect } from "react";
import "./PageFeedback.css";

function PageFeedback() {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });
const [errors, setErrors] = useState({});
const [responseMsg, setResponseMsg]=useState("");
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };
useEffect(()=>{
const savedMobile=localStorage.getItem("userMobile");
if (savedMobile){
  setForm((prev)=>({
    ...prev,
    phone:savedMobile,
  }));
}
},[]
);
 const handleSubmit = async () => {
 if(
  !form.name.trim() ||
  
  !form.email.trim() ||
  !form.message.trim()
 ){
  setErrors({common: "All fields are required!"});
   setResponseMsg("");
  return;
 }
 setErrors({});
  try {
    const response = await fetch(
      "https://gitstool.in/dscsc/shop_app/submit_suggestion.php",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: form.name,
          mobile: form.phone,
          email: form.email,
          message: form.message,
        }),
      }
    );

    const data = await response.json();
    console.log("Response:", data);   // 👈 print in console
    if (data.status==="success"){
      setResponseMsg("Feedback submitted successfully!");
      setForm ({name:"",phone:form.phone, email:"", message:""});
      setErrors({});
    }
    else if(data.status==="error" && data.message==="Failed to save Duplicate")
      {
      setResponseMsg("Suggestion already updated for the day!");
    }

  } catch (error) {
    console.error("Error:", error);
    alert("Something went wrong!");
  }
};

  return (
    <div className="feedback-container">
      <div className="feedback-card">
<div className="feedback-box">
        <label>Name</label>
        <div className="input-box">
          <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="black" strokeWidth="2">
            <path d="M12 12c2.7 0 5-2.3 5-5s-2.3-5-5-5-5 2.3-5 5 2.3 5 5 5zm0 2c-3.3 0-10 1.7-10 5v3h20v-3c0-3.3-6.7-5-10-5z"/>
          </svg>
          <input
            type="text"
            name="name"
            placeholder="Enter your name"
            onChange={handleChange}
          />
          
        </div>

        <label>Mobile Number</label>
        <div className="input-box">
       <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="black" strokeWidth="2">
           <path d="M22 16.92v3a2 2 0 0 1-2.18 2 
           19.79 19.79 0 0 1-8.63-3.07 
           19.5 19.5 0 0 1-6-6 
           19.79 19.79 0 0 1-3.07-8.67 
           A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 
           12.84 12.84 0 0 0 .7 2.81 
           2 2 0 0 1-.45 2.11L8.09 9.91 
           a16 16 0 0 0 6 6l1.27-1.27 
           a2 2 0 0 1 2.11-.45 
           12.84 12.84 0 0 0 2.81.7 
           A2 2 0 0 1 22 16.92z"/>
          </svg>
          <input
            type="text"
            name="phone"
           value={form.phone}
            onChange={handleChange}
          />
         
        </div>
        <label>Email</label>
        <div className="input-box">
          <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="black" strokeWidth="2">
            <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5-8-5V6l8 5 8-5v2z"/>
          </svg>
          <input
            type="email"
            name="email"
            placeholder="Enter your email"
            onChange={handleChange}
          />
         
        </div>

        <label>Message</label>
        <textarea
          name="message"
          placeholder="Share your feedback, suggestions, or report issues..."
          onChange={handleChange}
        />
        {errors.common && <p className="error">{errors.common}</p>}
        {responseMsg && <p className="response">{responseMsg}</p>}

        <button onClick={handleSubmit}>Submit Feedback</button>

        <p className="footer-text">
          Your feedback helps us improve our service
        </p>
      </div>
    </div></div>
  );
}                                                                                           

export default PageFeedback;